<div class="section">
<div class="tile is-ancestor">
    <div class="tile is-vertical is-12">
      <div class="tile">
        <div class="tile is-parent is-vertical">
          <article class="notification">
            <p class="is-size-1">Connecting IoT sensors with business operations.</p>
          </article>
          <article class="notification">
            <p class="is-size-4">Our Services</p>
            <p class="mt-4 mb-4">
              Leverage IOT, Machine Learning and AI to  get more done, with less effort. Tellsens AS provides a broad range of services in the IOT industry.
            </p>
          </article>
          <article class="tile is-child notification">
            <p class="is-size-4">Contact Us</p>
              <p class="subtitle mt-5 mb-5">
                <span class="tag is-danger is-large"><a target="_blank" href="https://calendly.com/tore-skarstein/tellsens-io-support">Schedule a video meeting with us</a></span>
              </p>
              <p class="subtitle mt-4 mb-4">
                E-mail <a href="mailto://support@tellsens.io" class="has-text-info">support@tellsens.no</a><br>
              </p>
              <p class="subtitle">
                  Phone +47 46 50 53 82
              </p>
              <p class="subtitle">
                  Office Address: Evjegata 10, N-6900, Norway 
              </p>
              <p class="mt-4 mb-4"><a href="/privacy.html">Personvernerklæring</a></p>
              <p class="mt-4 mb-4"><a href="/cookies.html">Informasjonskapsler</a></p>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child notification">
            <p class="is-size-4 mb-4">
              <span class="icon mr-4">
              <i class="fas fa-map"></i>
              </span> 
              Track and locate
            </p>
            <figure class="image is-4by3">
              <img src="/img/gps-tracking-tellsens-1.png" alt="map with marker">
            </figure>
            <p class="mt-4 mb-4">Fit your goods and equipment with GPS trackers and take full advantage of geolocation data in your business. View, filter and track down any asset on a map with
              superb satelite imagery and live map functionality. Equip personell with dedicated trackers or bring any handheld mobile or tablet and get a complete picture of
              your logistics operations.
            </p>
            <p class="mt-4 mb-4">
              Tellsens delivers infrastructure, hardware, networking, gateways, vpn to sensors and web application services.
            </p>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child notification">
            <p class="is-size-4 mb-4">
              <span class="icon mr-4">
              <i class="fas fa-gears"></i>
              </span> 
              Vibration Analysis
            </p>
            <figure class="image is-4by3">
              <img src="/img/vibration-analyzer-tellsens-1.jpg" alt="engine control room tablet">
            </figure>
            <p class="mt-4 mb-4">Our products are the most fully functional vibration analyzers on the market. They integrate advanced functions for Vibration Analysis and Dynamic Balancing with new Triaxial Wireless technology making them more portable and versatile.</p>
            <figure class="image is-4by3">
              <img src="/img/vibration-analyzer-tellsens-2.jpg" alt="engine control room computer">
            </figure>
            <p class="mt-4 mb-4">Furthermore, their compatibility with current mobile devices make them very easy to use and ultra-portable. Meet our improved functions for bearing and gearbox analysis and our new Machine Learning tool</p>
          </article>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .tile {
    background-color: whitesmoke;
  }
  a {
    text-decoration: none !important;
  }
</style>


